module.exports = __webpack_public_path__ + "assets/img/free_32.b53c2201.png";